// Replays queued actions when the connection returns — App Flow §7.3.
import type { QueryClient } from '@tanstack/react-query';
import { api } from './api.js';
import { drainQueue } from './offline.js';

export interface QueuedSubmit {
  contributionId: string;
  text: string | null;
  submit: boolean;
}
export interface QueuedReaction {
  editionId: string;
  target_type: 'page' | 'department';
  target_id: string;
}
export interface QueuedUnreaction {
  editionId: string;
  reactionId: string;
}

const handlers = {
  'contribution.save': async (payload: QueuedSubmit) => {
    await api.updateContribution(payload.contributionId, {
      text_body: payload.text,
      ...(payload.submit ? { status: 'submitted' } : {}),
    });
  },
  'reaction.add': async (payload: QueuedReaction) => {
    await api.react(payload.editionId, {
      target_type: payload.target_type,
      target_id: payload.target_id,
      type: 'heart',
    });
  },
  'reaction.remove': async (payload: QueuedUnreaction) => {
    await api.unreact(payload.editionId, payload.reactionId);
  },
  'notification.read': async (payload: { id: string }) => {
    await api.markRead(payload.id);
  },
} as unknown as Record<string, (payload: never) => Promise<unknown>>;

export function startOfflineSync(queryClient: QueryClient) {
  if (typeof window === 'undefined') return;
  const run = async () => {
    if (!navigator.onLine) return;
    await drainQueue(handlers);
    await queryClient.invalidateQueries();
  };
  window.addEventListener('online', () => void run());
  void run();
}
